import styled from '@emotion/styled';

export const ConferenceContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	gap: 4rem;
	max-width: 135rem;
	width: 100%;
	margin: 0 auto;
	padding: 8rem 0rem;
	@media screen and (max-width: 1370px) {
		padding: 8rem 2rem;
	}
`;
export const ContentTabList = styled.div`
	max-width: 135rem;
	width: 100%;
	margin: 0 auto;
`;
export const ConferenceTitle = styled.h2`
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #212529;
	text-align: center;
`;
export const ConferenceSearchBox = styled.div`
	display: flex;
	gap: 0.4rem;
	justify-content: flex-end;
	width: 100%;
	height: 4.4rem;
`;
export const ConferenceBoardBox = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 2rem;
	flex: 1;
`;
export const ConferenceGalleryBox = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 2rem;
	width: 100%;
	@media screen and (max-width: 1370px) {
		grid-template-columns: repeat(3, 1fr);
	}
	@media screen and (max-width: 1024px) {
		grid-template-columns: repeat(2, 1fr);
	}
	@media screen and (max-width: 768px) {
		grid-template-columns: repeat(1, 1fr);
	}
`;
export const GalleryItemBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	min-width: 0;
	cursor: pointer;
	.img_box {
		width: 100%;
		height: 22rem;
		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
`;

export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
	.title {
		font-size: ${(props) => props.theme.fontSize.sizeXl};
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		line-height: 130%;
		letter-spacing: -0.6px;
		color: #212529;
		width: 100%;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	.date {
		font-size: ${(props) => props.theme.fontSize.sizeMd};
		font-weight: ${(props) => props.theme.fontWeight.weightRegular};
		line-height: 100%;
		letter-spacing: -0.6px;
		color: #868e96;
	}
`;
export const ConferenceGalleryImgBox = styled.div`
	height: 22rem;
`;
export const NoData = styled.p`
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 20rem;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	text-align: center;
`;
